import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import { Divider } from "../../elements/Divider";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { GridRow } from "../../layout/GridRow";
import { TextPlaceholder } from "../../elements/TextPlaceholder";
import { Paragraph } from "../../typography/Paragraph";
import { Quote } from "../../elements/Quote";
import { Rating } from "../../elements/Rating";
import { Subheading } from "../../typography/Subheading";
import { Heading } from "../../typography/Heading";
import { getReviewerCategoryAndStayDateString } from "./utils/getReviewerCategoryAndStayDateString";
import { getReviewerNameAndLocationString } from "./utils/getReviewerNameAndLocationString";
export var Component = function Component(_ref) {
  var isShowingPlaceholder = _ref.isShowingPlaceholder,
      ratingNumber = _ref.ratingNumber,
      reviewerCategory = _ref.reviewerCategory,
      reviewerLocation = _ref.reviewerLocation,
      reviewerName = _ref.reviewerName,
      reviewResponse = _ref.reviewResponse,
      reviewerStayDate = _ref.reviewerStayDate,
      reviewText = _ref.reviewText,
      reviewTitle = _ref.reviewTitle;
  return React.createElement(Card, {
    fluid: true
  }, React.createElement(Card.Content, null, React.createElement(Card.Meta, null, React.createElement(Grid, null, React.createElement(GridRow, {
    verticalAlign: "middle"
  }, React.createElement(GridColumn, {
    computer: 6,
    mobile: 12,
    tablet: 7
  }, isShowingPlaceholder ? React.createElement(TextPlaceholder, {
    length: "medium"
  }) : React.createElement(Subheading, null, getReviewerNameAndLocationString(reviewerName, reviewerLocation))), React.createElement(GridColumn, {
    computer: 6,
    mobile: 12,
    tablet: 5,
    textAlign: "right",
    verticalAlign: "middle"
  }, !isShowingPlaceholder && React.createElement(Rating, {
    isShowingNumeral: false,
    ratingNumber: ratingNumber
  }))))), React.createElement(Divider, null), isShowingPlaceholder ? React.createElement(Fragment, null, React.createElement(TextPlaceholder, {
    length: "medium"
  }), React.createElement(Divider, null), React.createElement(TextPlaceholder, null), React.createElement(TextPlaceholder, null), React.createElement(TextPlaceholder, {
    length: "short"
  })) : React.createElement(Fragment, null, React.createElement(Card.Header, null, React.createElement(Heading, null, reviewTitle)), React.createElement(Card.Description, null, React.createElement(Paragraph, null, reviewText))), React.createElement(Divider, null), !!reviewResponse && React.createElement("div", null, React.createElement(Quote, {
    quoteDateTime: reviewResponse.dateTime,
    quoteSource: reviewResponse.source,
    quoteText: reviewResponse.text
  }), React.createElement(Divider, null)), React.createElement(Card.Description, {
    textAlign: "right"
  }, !isShowingPlaceholder && getReviewerCategoryAndStayDateString(reviewerCategory, reviewerStayDate))));
};
Component.displayName = 'Review';
Component.defaultProps = {
  isShowingPlaceholder: false,
  reviewResponse: null,
  reviewerLocation: undefined,
  reviewerStayDate: '',
  reviewerCategory: ''
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  isShowingPlaceholder: PropTypes.bool,
  ratingNumber: PropTypes.number.isRequired,
  reviewResponse: PropTypes.shape({
    dateTime: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }),
  reviewText: PropTypes.string.isRequired,
  reviewTitle: PropTypes.string.isRequired,
  reviewerCategory: PropTypes.string,
  reviewerLocation: PropTypes.string,
  reviewerName: PropTypes.string.isRequired,
  reviewerStayDate: PropTypes.string
} : {};